import { Component, ChangeDetectionStrategy, Injector } from '@angular/core';
import { FeatureComponent } from 'src/framing/feature.component';
import { CadAppController } from '../../cad-app.controller';
import { CadAppModel } from '../../cad-app.model';
import { CadAppView } from '../../cad-app.view';
import {ConfigService} from 'cad/core/services/config/config.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'ui-global-footer',
  templateUrl: './footer.component.html',
  styleUrls: [ './footer.component.less' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent extends FeatureComponent<CadAppModel, CadAppView, CadAppController> {
  envMessage: string = '';
  constructor(
    private matSnackBar: MatSnackBar,
    public configService: ConfigService,
    controller: CadAppController,
    injector: Injector,
  ) {
    super(controller, injector);
    if (this.configService.cadConfig.isDev) {
      this.envMessage = this.configService.cadConfig.envName;
    }
  }
}
